const CHARGE_EMAIL_INITIAL_DAYS_DEFAULT = 60;
const CHARGE_EMAIL_RESEND_DAYS_DEFAULT = 14;

// Tamanho maximo do markup SVG aceito nos ativos de marca do banco (brandIcon / brandLogo)
const BRAND_SVG_MAX_LENGTH = 200000;

// Tipos de operacao para configuracao de janelas de liquidacao
const LIQUIDATION_OPERATION_TYPE = {
  BUY: 'BUY',
  SELL: 'SELL',
};

// Export para ES modules (frontend)
export { CHARGE_EMAIL_INITIAL_DAYS_DEFAULT, CHARGE_EMAIL_RESEND_DAYS_DEFAULT, BRAND_SVG_MAX_LENGTH, LIQUIDATION_OPERATION_TYPE };

// Export para CommonJS (backend)
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { CHARGE_EMAIL_INITIAL_DAYS_DEFAULT, CHARGE_EMAIL_RESEND_DAYS_DEFAULT, BRAND_SVG_MAX_LENGTH, LIQUIDATION_OPERATION_TYPE };
}
